import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
//#region src/FirebaseFunctionProvider.ts
/**
* Firebase implementation of IFunctionProvider
*/
var FirebaseFunctionProvider = class {
	constructor(app, options) {
		this.callableCache = /* @__PURE__ */ new Map();
		this.functions = getFunctions(app, options?.region);
		if (options?.emulator) {
			connectFunctionsEmulator(this.functions, options.emulator.host, options.emulator.port);
			console.log(`[Functions] Connected to emulator at ${options.emulator.host}:${options.emulator.port}`);
		}
	}
	async callFunction(functionName, data) {
		let callable = this.callableCache.get(functionName);
		if (!callable) {
			callable = httpsCallable(this.functions, functionName);
			this.callableCache.set(functionName, callable);
		}
		const result = await callable(data);
		if (!result || !result.data) throw new Error(`Invalid response from function: ${functionName}`);
		return {
			statusCode: result.data.statusCode,
			resultData: result.data.resultData
		};
	}
	setRegion(region) {
		console.warn("FirebaseFunctionProvider: setRegion called but region change requires re-initialization");
	}
	/**
	* Get the underlying Firebase Functions instance
	* (For Firebase-specific operations)
	*/
	getFirebaseFunctions() {
		return this.functions;
	}
};
//#endregion
export { FirebaseFunctionProvider };
